import { render, staticRenderFns } from "./SensorTypeTable.vue?vue&type=template&id=531946fe&"
import script from "./SensorTypeTable.vue?vue&type=script&lang=js&"
export * from "./SensorTypeTable.vue?vue&type=script&lang=js&"
import style0 from "./SensorTypeTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports